import React from 'react';

const Card = ({ 
  children, 
  className = '',
  hoverable = false,
  ...props 
}) => {
  return (
    <div 
      className={`
         rounded-lg border overflow-hidden
        ${hoverable ? 'transition-transform duration-300 ' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;